import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ListChecks, X } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';

// Dashboard "To finish" list — saved Update & Resend items waiting to be sent.
export const PendingResendsWidget = () => {
  const { api } = useAuth();
  const navigate = useNavigate();
  const [d, setD] = useState({ rows: [], due: 0 });
  const load = () => api.get('/update-resend/pending').then((r) => setD(r.data)).catch(() => {});
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const today = new Date().toLocaleDateString('en-CA', { timeZone: 'Pacific/Auckland' });

  return (
    <div className="bg-white border border-[#E2E2DF] rounded-md p-4" data-testid="to-finish-widget">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2"><ListChecks size={15} className="text-[#D35400]" />
          <div className="text-sm font-bold text-slate-800">To finish · updates to resend</div>
          {d.due > 0 && <span data-testid="to-finish-due" className="text-[10px] px-2 py-0.5 rounded-full bg-red-600 text-white">{d.due} due</span>}
        </div>
        <button data-testid="to-finish-new-btn" onClick={() => navigate('/update-resend')} className="text-xs font-semibold text-[#0F4F1B] hover:underline">+ Update & Resend</button>
      </div>
      {d.rows.length === 0 ? <div className="text-xs text-slate-400">Nothing waiting.</div> : (
        <div className="divide-y divide-[#F1EFEC]">
          {d.rows.map((r) => (
            <div key={r.id} className="flex items-center gap-2 py-1.5 text-xs" data-testid={`to-finish-row-${r.id}`}>
              <span className={`font-mono w-24 ${(r.remind_on || today) <= today ? 'text-red-600 font-semibold' : 'text-slate-500'}`}>{r.remind_on || '—'}</span>
              <span className="font-mono">A{r.appraisal_no}</span><span className="flex-1 truncate">{r.client_name} · {(r.changes || []).length} change(s) · {(r.doc_keys || []).length} doc(s)</span>
              <button data-testid={`to-finish-open-${r.id}`} onClick={() => navigate(`/update-resend?pending=${r.id}`)} className="text-[#0F4F1B] font-semibold hover:underline">Finish</button>
              <button data-testid={`to-finish-dismiss-${r.id}`} title="Dismiss" onClick={() => api.delete(`/update-resend/pending/${r.id}`).then(load)} className="text-slate-400 hover:text-red-600"><X size={13} /></button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
